<template>
    <div :class="['d-flex flex-row justify-content-around flex-wrap',
            isTemplatePreview ? 'flex-md-column justify-content-md-center' : ''
        ]">
        <div v-for="(element, index) in displayedElements"
             class="element d-flex justify-content-center align-items-center m-2"
             :key="element.tag + index"
             :availableLayer="true"
             :idx="index">
            <div>
                <span class="element-item"
                      :style="isTemplatePreview ? {color: '#000'} : ''">
                    {{element.desc}}
                </span>
                <div :style="{height: '100px', width: '100px', position: 'relative'}">
                    <component :is="element.type + 'Layer'" class="p-0 m-0"
                               :layer="element"/>
                </div>

            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import LayersMixin from '../../../../../../../mixins/LayersMixin.vue';

import Modal from '../../../../../../Shared/Modal/FunctionalModal.vue';
export default {
    name: 'ElementsCategory',
    props: {
        templateStyle: {
            type: Object,
            required: false
        }
    },
    data () {
        return {
            elements: []
        };
    },
    computed: {
        computedElements () {
            let els = [...this.getFreshElements()];
            els.forEach(element => {
                element.attrs.style = {
                    ...element.attrs.style,
                    ...this.templateStyle
                };
                if(element.attrs) {
                    if(element.attrs.style) {
                        if(element.attrs.style['background-image']) {
                            element.attrs.style['background-image'] =
                                element.attrs.style['background-image']
                                    .replace('http://coldstorage:1337',
                                        `${this.$axios.defaults.baseURL}/coldstorage`
                                    );
                        }
                    }
                }
            });
            return els;
        },
        displayedElements () {
            return this.templateStyle ? this.computedElements : this.elements;
        },
        isTemplatePreview () {
            return this.templateStyle;
        }
    },
    components: {
        Modal
    },
    mixins: [LayersMixin],
    methods: {
        getFreshElements () {
            return [
                {
                    tag: 'div',
                    desc: 'Container',
                    type: 'element',
                    isImage: false,
                    attrs: {
                        style: {
                            width: '50%',
                            height: '50%',
                            'background-color': '#000',
                            position: 'absolute',
                            top: '0%',
                            left: '0%'
                        },
                        domProps: {
                            draggable: true
                        }
                    }
                },
                {
                    tag: 'div',
                    desc: 'Image',
                    isImage: true,
                    type: 'element',
                    attrs: {
                        style: {
                            width: '50%',
                            height: '50%',
                            'background-color': '#eee',
                            'background-image': 'url(https://d30y9cdsu7xlg0.cloudfront.net/png/38-200.png)',
                            'background-position': 'center center',
                            'background-size': 'cover',
                            position: 'absolute',
                            top: '0%',
                            left: '0%'
                        },
                        domProps: {
                            draggable: true
                        }
                    }
                },
                {
                    tag: 'p',
                    desc: 'Text',
                    type: 'element',
                    editable: true,
                    isImage: false,
                    attrs: {
                        style: {
                            width: '50%',
                            height: '50%',
                            'background-color': '#fff',
                            color: '#000',
                            margin: 0,
                            position: 'absolute',
                            top: '0%',
                            left: '0%'
                        },
                        domProps: {
                            draggable: true
                        }
                    },
                    value: 'Your text here'
                }
            
            ];
        }
    },
    created () {
        this.elements = this.getFreshElements();
    }
};

</script>

<style lang="scss" scoped>
    .title {
        color: white;
    }
    
    .text-center {
        text-align: center;
    }
    
    .element-item {
        color: white;
    }
</style>
